// Estilos compartidos de la banda de jornada, el diálogo de confirmación y la compra de sueltas (#1887).
// Salen del prototipo aprobado (`tools/mockups/jornada_boton/`, dirección B) y usan SOLO tokens de `theme.js`.
export const FUENTE = "-apple-system, BlinkMacSystemFont, 'SF Pro Text', system-ui, 'Inter', 'Segoe UI', sans-serif";

export const primarySx = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: 13,
  lineHeight: 1.2,
  borderRadius: "10px",
  px: 1.5,
  py: 0.75,
  minHeight: 32,
  whiteSpace: "nowrap",
  flexShrink: 0,
  color: "var(--text-on-primary)",
  backgroundColor: "var(--color-primary)",
  "&:hover": { backgroundColor: "var(--color-primary-soft)" },
  "&.Mui-disabled": { color: "var(--text-faint)", backgroundColor: "rgba(var(--fg-rgb),0.08)" },
};

export const ghostSx = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: 13,
  lineHeight: 1.2,
  borderRadius: "10px",
  px: 1.5,
  py: 0.75,
  minHeight: 32,
  whiteSpace: "nowrap",
  flexShrink: 0,
  color: "var(--text-primary)",
  border: "1px solid rgba(var(--fg-rgb),0.16)",
  backgroundColor: "transparent",
  "&:hover": { backgroundColor: "rgba(var(--fg-rgb),0.07)" },
};

export const chipSx = (mobile) => ({
  textTransform: "none",
  fontFamily: FUENTE,
  fontWeight: 600,
  fontSize: mobile ? 12 : 12.5,
  lineHeight: 1.2,
  borderRadius: "999px",
  px: mobile ? 1 : 1.25,
  py: 0.5,
  minHeight: mobile ? 30 : 32,
  whiteSpace: "nowrap",
  flexShrink: 0,
  color: "var(--text-primary)",
  border: "1px solid rgba(var(--fg-rgb),0.18)",
  backgroundColor: "rgba(var(--fg-rgb),0.04)",
  "&:hover": { backgroundColor: "rgba(var(--fg-rgb),0.09)" },
  "& .MuiButton-startIcon": { mr: 0.5, ml: 0 },
  "& .MuiButton-startIcon svg": { fontSize: 14, color: "var(--accent-onboarding)" },
});

// Hoja de los diálogos (confirmar, elegir, compra): mismo molde que el mockup (radio 20, borde suave, sin imagen de fondo).
export const paperSx = {
  backgroundColor: "var(--bg-elevated)",
  backgroundImage: "none",
  borderRadius: "20px",
  border: "1px solid rgba(var(--fg-rgb),0.14)",
  width: "100%",
  maxWidth: 420,
  m: 2,
  p: 2.5,
  boxSizing: "border-box",
};

// zIndex del diálogo: la pantalla de bloqueo de `SuscripcionGate` vive en 20000 y estos diálogos se abren ENCIMA
// (la compra se abre desde el bloqueo; el aviso de `sin_jornadas` también puede llegar con ella a la vista).
export const Z_ENCIMA_DEL_GATE = 20001;
